
import moment from 'moment';
import CryptoJS from "crypto-js";
import LocalStorageService from "./LocalStorageService";
import jwt from 'jsonwebtoken'

const FuncionesAyuda = (function () {

    function getTextoLimpioMayus(texto){
        return texto.trim().toLowerCase().toUpperCase();
    }

    function getTextoLimpioMinus(texto){
        return texto.trim().toLowerCase();
    }

    function getFecha(fecha){   
        const nuevaFecha = moment(fecha).format("YYYY-MM-DD");
        return moment(nuevaFecha).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    }

    function getHora(hora){   
        return moment(hora).format("HH:mm:ss");
    }

    function getFechaHora(fecha, hora){
        const nuevaFecha = moment(fecha).format("YYYY-MM-DD");
        const nuevaHora = moment(nuevaFecha + " " + hora);
        return moment(nuevaHora).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    }

    function getFechaActual(){
        return moment(new Date()).utc().format("YYYY-MM-DD");
    }

    function getFechaHoraActual(){
        return moment(new Date()).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
    }

    function getFechaLocal(fecha){
        let date = new Date(fecha);
        let options = {
          year: "numeric",
          month: "long",
          day: "numeric",
        };
        return date.toLocaleDateString("es-MX", options);
    }

    function getFechaHoraLocal(fecha){
        let date = new Date(fecha);
        let options = {
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hour12: "true",
        };
        return date.toLocaleDateString("es-MX", options);
    }

    function groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    }
    function msi() {
        return [ 1, 3, 6, 9, 12, 15, 18,24, 36];
    }

    function encriptar(dato) {
        let encriptado
        if (process.env.VUE_APP_SECURE_API !== undefined &&
            (process.env.VUE_APP_SECURE_API === true || process.env.VUE_APP_SECURE_API === 'true')) {

            var keyForCryptoJS = CryptoJS.enc.Base64.parse(btoa(process.env.VUE_APP_SECURE_KEY_API));

            encriptado = CryptoJS.AES.encrypt(JSON.stringify(dato), keyForCryptoJS, {
                mode: CryptoJS.mode.ECB
            }).toString();
        }

        return encriptado;
    }

    function desencriptar(dato) {
        let desencriptado;
        const keyForCryptoJS = CryptoJS.enc.Base64.parse(btoa(process.env.VUE_APP_SECURE_KEY_API));
        const decodeBase64 = CryptoJS.enc.Base64.parse(dato);

        desencriptado = CryptoJS.AES.decrypt({ciphertext:decodeBase64}, keyForCryptoJS,
            {
                mode: CryptoJS.mode.ECB
            }
        ).toString(CryptoJS.enc.Utf8);

        return desencriptado;
    }


    /**
     * Genera un token JWT (JSON Web Token) para un usuario específico.
     *
     * @param {string} userId - El ID del usuario para el que se generará el token. Este parámetro es obligatorio.
     * @returns {string} - El token JWT generado.
     *
     * La función crea un payload que incluye el ID del usuario y otros atributos opcionales.
     * Luego, firma el payload con una clave secreta y establece una expiración de 1 hora para el token.
     *
     * @example
     * // Generar un token para el usuario con ID '12345'
     * const token = generarToken('12345');
     * console.log(token);
     */
    function generarToken(userId) {
        const payload = {
            user_id: userId, // Required
            email: '',// Optional
            sensitive_attribute1: 'sensitive-data', // Optional
            sensitive_attribute2: 'sensitive-data', // Optional
            sensitive_attribute3: 'sensitive-data'// Optional
        };

        return  jwt.sign(payload, process.env.VUE_APP_INTERCOM_SECRET_KEY, {expiresIn: '1h'}, null);
    }
        /**
     * Configura e inicializa el widget de Intercom con los datos del usuario actual.
     *
     * @param {string} userId - Identificador único del usuario.
     * @param {string} nombreCompleto - Nombre completo del usuario.
     * @param {string} hmac - Código token generado para la verificación de identidad.
     * @param {string} [clinicaActual.idClinica] - ID de la clínica actual.
     * @param {string} [clinicaActual.nombreClinica] - Nombre de la clínica actual.
     *
     * @description
     * Esta función configura `window.intercomSettings` con los datos del usuario y carga el widget de Intercom.
     * Utiliza variables de entorno para `api_base` y `app_id`, y puede incluir información de la clínica si se desea.
     */
    function mostrarIntercom(){
        const localStorageService = LocalStorageService.getService();
        const userId = localStorageService.getIdUsuario().toString();
        const nombreCompleto = localStorageService.getNombreCompletoUsuario();

        const token = generarToken(userId)

            window.intercomSettings = {
            api_base: process.env.VUE_APP_INTERCOM_API_BASE,
            app_id: process.env.VUE_APP_INTERCOM_APP_ID,
            user_id:userId,
            name: nombreCompleto,
            intercom_user_jwt : token,
            created_at: Math.floor(new Date().getTime() / 1000)
        };
        (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/'+process.env.VUE_APP_INTERCOM_APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();

    }
    /**
     * Configura para finalizacion el widget de Intercom.
     *
     *
     * @description
     * Esta función configura `window.Intercom` para finalizar  el widget de Intercom al salir de la pantalla.
     */
    function ocultarIntercom(){
        window.Intercom('shutdown');
    }

    return{
        limpiarTextoMayus: getTextoLimpioMayus,
        limpiarTextoMinus: getTextoLimpioMinus,
        traerFecha: getFecha,
        traerFechaHora: getFechaHora,
        traerFechaActual: getFechaActual,
        traerFechaHoraActual: getFechaHoraActual,
        traerFechaLocal: getFechaLocal,
        traerFechaHoraLocal: getFechaHoraLocal,
        traerHora: getHora,
        groupBy: groupBy,
        msi: msi,
        encriptar: encriptar,
        desencriptar: desencriptar,
        mostrarIntercom: mostrarIntercom,
        ocultarIntercom:ocultarIntercom
     }
})();
export default FuncionesAyuda;
